import { DayOfWeek } from "@js-joda/core";

const firstDayMapper: Record<number, DayOfWeek> = {
	1: DayOfWeek.MONDAY,
	2: DayOfWeek.TUESDAY,
	3: DayOfWeek.WEDNESDAY,
	4: DayOfWeek.THURSDAY,
	5: DayOfWeek.FRIDAY,
	6: DayOfWeek.SATURDAY,
	7: DayOfWeek.SUNDAY,
};

export function getUserWeekStart() {
	const osLocale = Intl.DateTimeFormat().resolvedOptions().locale;
	const locale = new Intl.Locale(osLocale);

	// This function is not available in Firefox and pre-2024 browser
	// requires polyfill `@bart-krakowski/get-week-info-polyfill`
	// see: https://bugzilla.mozilla.org/show_bug.cgi?id=1693576
	// see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getWeekInfo

	return firstDayMapper[locale.getWeekInfo().firstDay];
}
